import { Component, Input, forwardRef, ViewChild, ViewEncapsulation, Inject, Optional } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepicker } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { DashboardComponent } from '../../dashboard.component';
import { InverterDetailsComponent } from '../../inverter-details/inverter-details.component';
import { WmsInverterDataComponent } from '../../wms-inverter-data/wms-inverter-data.component';
const moment = _rollupMoment || _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['year-picker.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YearPickerComponent),
      multi: true,
    },
  ],
})
export class YearPickerComponent implements ControlValueAccessor {
  /** Component label */
  @Input() label = '';

  _max: Moment;
  @Input() get max(): number | Date {
    return this._max ? this._max.year() : undefined;
  }
  set max(max: number | Date) {
    if (max) {
      const momentDate = typeof max === 'number' ? moment([max, 0, 1]) : moment(max);
      this._max = momentDate.isValid() ? momentDate : undefined;
    }
  }

  _min: Moment;
  @Input() get min(): number | Date {
    return this._min ? this._min.year() : undefined;
  }
  set min(min: number | Date) {
    if (min) {
      const momentDate = typeof min === 'number' ? moment([min, 0, 1]) : moment(min);
      this._min = momentDate.isValid() ? momentDate : undefined;
    }
  }

  @Input() touchUi = false;

  @ViewChild(MatDatepicker,{static: false}) _picker: MatDatepicker<Moment>;

  _inputCtrl: FormControl = new FormControl();

  // Function to call when the date changes.
  onChange = (year: Date) => { };

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => { };

  writeValue(date: Date): void {
    if (date && this._isYearEnabled(date.getFullYear())) {
      const momentDate = moment(date);
      if (momentDate.isValid()) {
        this._inputCtrl.setValue(moment(date), { emitEvent: false });
      }
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this._picker.disabled = true : this._picker.disabled = false;

    isDisabled ? this._inputCtrl.disable() : this._inputCtrl.enable();
  }

  _yearSelectedHandler(chosenDate: Moment, datepicker: MatDatepicker<Moment>) {

    if (!this._isYearEnabled(chosenDate.year())) {

      datepicker.close();
      return;
    }

    this._inputCtrl.setValue(chosenDate, { emitEvent: false });
    this.onChange(chosenDate.toDate());
    this.onTouched();
    datepicker.close();

    if(this.parent !=null){
      if(this.parent.roleName =='normal'){
        this.parent.chosenYearHandler();

      }else if (this.parent.roleName =='wms'){
        this.parent.chosenYearHandlerWms();
      }
      else if (this.parent.roleName =='ze'||this.parent.roleName =='dg'){
        this.parent.chosenYearHandlerZE();
      }
    }else if(this.parentInverter !=null){
      if(this.parentInverter.roleName =='normal'){


        if(this.parentInverter.selectedTabSection=='YearInv')
        {
          this.parentInverter.changeYearInv();
        }
        else if(this.parentInverter.selectedTabSection=='Year'){
          this.parentInverter.chosenYearHandler();
        }

      }

      if(this.parentInverter.roleName =='ze'||this.parentInverter.roleName =='dg' ){


        if(this.parentInverter.selectedTabSection=='YearInv')
        {
          this.parentInverter.changeYearInvZE();
        }
        else if(this.parentInverter.selectedTabSection=='Year'){
          this.parentInverter.chosenYearHandlerZE();
        }

      }

      else if (this.parent.roleName =='wms'){

      }

    }else if(this.wmsinvertercomponent !=null){

      if(this.wmsinvertercomponent.selectedTabSection=='YearInv')
      {
        this.wmsinvertercomponent.changeYearInv();
      }
      else if(this.wmsinvertercomponent.selectedTabSection=='Year'){
        this.wmsinvertercomponent.changeYear();
      }


    }
  }

  _openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
    }
  }

  _openDatepickerOnFocus(datepicker: MatDatepicker<Moment>) {
    setTimeout(() => {
      if (!datepicker.opened) {
        datepicker.open();
      }
    });
  }

  /** Whether the given year is enabled. */
  private _isYearEnabled(year: number) {
    // disable if the year is greater than maxDate lower than minDate
    if (year === undefined || year === null ||
      (this._max && year > this._max.year()) ||
      (this._min && year < this._min.year())) {
      return false;
    }

    return true;
  }
  constructor(@Inject(DashboardComponent) @Optional() private parent?: DashboardComponent,@Inject(InverterDetailsComponent) @Optional() private parentInverter?: InverterDetailsComponent,
  @Inject(WmsInverterDataComponent) @Optional() private wmsinvertercomponent?: WmsInverterDataComponent){

  }
}
